import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheArchitectSEntry from "./sections/TheArchitectSEntry";
import TheBenewealthStandard from "./sections/TheBenewealthStandard";
import StrategicPillars from "./sections/StrategicPillars";
import ThePathToFunding from "./sections/ThePathToFunding";
import EliteClientInsights from "./sections/EliteClientInsights";
import SecureYourPosition from "./sections/SecureYourPosition";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheArchitectSEntry />
      <TheBenewealthStandard />
      <StrategicPillars />
      <ThePathToFunding />
      <EliteClientInsights />
      <SecureYourPosition />
      <Footer />
    </div>;
}